import api from "@/api/v1-jwt/config/api";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";
import clientSettingsQueryKeys from "./query-keys";
import { ClientSetting, SettingKey, SettingCategory } from "./types";

export interface UpdateInvoiceSettingsPayload {
  category: SettingCategory;
  key: SettingKey;
  value: any;
}

interface UpdateInvoiceSettingsParams {
  userId: string;
  payload: UpdateInvoiceSettingsPayload;
}

const updateInvoiceSettings = async ({
  userId,
  payload,
}: UpdateInvoiceSettingsParams): Promise<ClientSetting> => {
  const url = `/platform/client-settings/${userId}`;
  const { data } = await api.patch(url, payload);
  return data;
};

export const useUpdateInvoiceSettings = (
  options?: Omit<
    UseMutationOptions<ClientSetting, Error, UpdateInvoiceSettingsParams>,
    "mutationFn"
  >
) => {
  const queryClient = useQueryClient();

  return useMutation<ClientSetting, Error, UpdateInvoiceSettingsParams>({
    ...options,
    mutationFn: updateInvoiceSettings,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: clientSettingsQueryKeys.all,
      });

      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
  });
};
